export const GOOGLE_REQUEST = 'GOOGLE_REQUEST'
export const GOOGLE_SUCCESS = 'GOOGLE_SUCCESS'
export const GOOGLE_FAILURE = 'GOOGLE_FAILURE'